import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminProcApi } from "../../api";
import { ProcError, ProcForm, ProcSection } from "../../components/ProcurementLayout";
import { useMutation } from "../../hooks";

export default function TenderCreatePage() {
  const navigate = useNavigate();

  const [tenderNo, setTenderNo] = useState("");
  const [description, setDescription] = useState("");
  const [openingDate, setOpeningDate] = useState("");
  const [openingTime, setOpeningTime] = useState("");
  const [venue, setVenue] = useState("");
  const [attendeesText, setAttendeesText] = useState("");
  const [bidsReceived, setBidsReceived] = useState(0);

  const { mutate, loading, error } = useMutation(async () => {
    if (!tenderNo.trim()) throw new Error("Tender number is required.");
    const attendees = attendeesText
      .split(/[\n,]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    await adminProcApi.createTender({
      tenderNo,
      description,
      openingDate,
      openingTime,
      venue,
      attendees,
      bidsReceived,
      presidingOfficerUserId: null,
      presidingOfficerUsername: null,
    });
    navigate("/procurement/admin/tenders");
  });

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <Link to="/procurement/admin/tenders" className="text-sm text-emerald-700 hover:underline">&larr; Back to Tender Register</Link>
      </div>

      <ProcForm formNo="PROC-FRM-14" title="Tender Opening Register">
        {error && <ProcError message={error} />}

        <ProcSection title="Tender Details">
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Tender No *</label>
              <input type="text" value={tenderNo} onChange={(e) => setTenderNo(e.target.value)} className="w-full rounded-xl border px-3 py-2 text-sm" required />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Description</label>
              <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} className="w-full rounded-xl border px-3 py-2 text-sm" />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Opening Date</label>
              <input type="date" value={openingDate} onChange={(e) => setOpeningDate(e.target.value)} className="w-full rounded-xl border px-3 py-2 text-sm" />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Opening Time</label>
              <input type="time" value={openingTime} onChange={(e) => setOpeningTime(e.target.value)} className="w-full rounded-xl border px-3 py-2 text-sm" />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Venue</label>
              <input type="text" value={venue} onChange={(e) => setVenue(e.target.value)} className="w-full rounded-xl border px-3 py-2 text-sm" />
            </div>
            <div>
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Bids Received</label>
              <input type="number" value={bidsReceived} min={0} onChange={(e) => setBidsReceived(Number(e.target.value))} className="w-full rounded-xl border px-3 py-2 text-sm" />
            </div>
            <div className="sm:col-span-2">
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Attendees</label>
              <textarea value={attendeesText} onChange={(e) => setAttendeesText(e.target.value)} rows={4} placeholder="One name per line or comma-separated" className="w-full rounded-xl border px-3 py-2 text-sm" />
            </div>
          </div>
        </ProcSection>

        <div className="flex justify-end gap-3 pt-2">
          <Link to="/procurement/admin/tenders" className="rounded-xl border px-5 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50">Cancel</Link>
          <button type="button" onClick={() => mutate()} disabled={loading} className="rounded-xl bg-emerald-700 px-5 py-2.5 text-sm font-semibold text-white hover:bg-emerald-800 disabled:opacity-60">
            {loading ? "Saving…" : "Save Entry"}
          </button>
        </div>
      </ProcForm>
    </div>
  );
}
